module.exports = {
    ALL: [
        {
            name: 'Paypal',
            logo: 'paypal.png',
            amount: {
                USD: [10, 20, 30, 50, 300, 500],
                TWD: [200, 500, 1000, 2000, 10000, 20000],
                EUR: [10, 20, 30, 50],
                HKD: [50, 100, 200, 500],
                PHP: [500, 1000, 2000],
                SGD: [10, 20, 30, 50, 100],
                THB: [200, 300, 500, 1000, 2000]
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/config/pay/paypal.js